// from is inclusive, to is exclusive
export function range(from: number, to: number): number[] {
    const result: number[] = [];
    for (let i = from; i < to; i++) {
        result.push(i);
    }

    return result;
}
